import { memo } from 'react'
import cn from 'classnames'

import { LOADER_SIZE } from './config'
import type { LoaderProps } from './types'

import styles from './Loader.module.scss'

/**
 * Минималистичный спиннер. В продукте почти не используется — везде скелетоны
 * (правило 14), исключение — кнопка во время отправки и редкие асинхронные точки.
 */
export const Loader = memo(function Loader(props: LoaderProps) {
  const { size = 'M', theme = 'ACCENT' } = props
  const diameter = LOADER_SIZE[size]

  return (
    <span
      className={cn(styles.root, styles[`theme_${theme}`])}
      style={{ width: diameter, height: diameter }}
      role='status'
      aria-label='Загрузка'
    />
  )
})
